import BaseButton from 'base-components/BaseButton/BaseButton';
import BaseModal from 'base-components/BaseModal/BaseModal';
import { Dispatch, SetStateAction } from 'react';
import {  ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import BaseForm from 'base-components/BaseForm/BaseForm';
import 'scss/Main.scss';

type MaintenanceChangeModalProps = {
    isOpen?: boolean;
    toggle: Dispatch<SetStateAction<boolean>>;
    handleChange: () => void;
    title: string;
    text: string;
};

const MaintenanceDeleteModal = ({ isOpen = false, toggle, handleChange, title, text }: MaintenanceChangeModalProps) => {
    const handleSubmit = () => {
        handleChange()
        toggle(false)
    }

    return (
        <BaseModal
            size="xl"
            isOpen={isOpen}
            toggle={() => toggle(false)}
            scrollable
            className="clients__modal"
        >
            <BaseForm<{}>
                onSubmit={handleSubmit}
                defaultValues={{ comment: '' }}
            >
                <ModalHeader toggle={() => toggle(false)}>
                    { title }
                </ModalHeader>
                <ModalBody className="custom-scrollbar p-8">
                    { text }
                </ModalBody>
                <ModalFooter>
                    <BaseButton type='submit' color="success" >
                        Да
                    </BaseButton>
                    <BaseButton color="secondary" onClick={() => toggle(false)}>
                        Закрыть
                    </BaseButton>
                </ModalFooter>
            </BaseForm>            
        </BaseModal>
    );
};

export default MaintenanceDeleteModal;
